export function getAssetBaseUrl() {
  if (typeof window !== "undefined" && window.location.hostname.includes("sparkl.me")) {
    return "https://asset.sparkl.me/";
  }
  return "https://asset.sparkl.ac/";
}

export function getAssetUrl(path) {
  return `${getAssetBaseUrl()}${path}`;
}
